export default "__VITE_ASSET__ce62a38b__"